module.exports = __webpack_public_path__ + "static/media/couple-card.1018e86e.png";